import { Globals } from "./Globals";

export class QJournal {
  constructor() {
    this.fClass = null;
    this.fObjMgrList = null;
    this.fObjMgrNonPersist = null;

    this.fObjList = null;

    this.fJournalChanged = false;
    this.fID = null;
  }

  InitJournal() {
    this.fObjList = new Array();
    this.fID = Globals._journalID++;
  }

  FindObj(dbObj) {
    var n = this.fObjList.length;
    for (var i = 0; i < n; i++) {
      var sObj = this.fObjList[i];
      var srcObj = sObj.GetSourceObj();

      if (dbObj == srcObj) return i;
    }

    return -1;
  }

  JournalChanged() {
    return this.fJournalChanged;
  }

  JournalObjList(theClass) {
    if (this.fObjMgrList == null) {
      // var parentClass = dbObj.fParentClass;
      this.fClass = theClass;
      var objMgr = theClass.GetObjMgr();
      var objList = objMgr.GetObjectList();
      this.fObjMgrList = objList.slice(0);

      var objListNP = objMgr.GetObjectListNonPersist();
      this.fObjMgrNonPersist = objListNP.slice(0);
      this.fJournalChanged = true;
    }
  }

  AddToJournal(dbObj, newObj) {
    if (newObj) {
      this.JournalObjList(dbObj.fParentClass);
      var index = this.fObjMgrList.indexOf(dbObj);
      if (index > -1) {
        var newObject = this.fObjMgrList[index];
        this.fObjMgrList.splice(index, 1);
        this.fObjMgrNonPersist.push(newObject);
      }
      return;
    }

    var index = this.FindObj(dbObj);
    if (index == -1) {
      this.fJournalChanged = true;
      var serialClone = dbObj.SerialClone(true);
      this.fObjList.push(serialClone);
    }
  }

  Restore() {
    //  console.log("QJournal:Restore:", this.fID);
    //  return;
    if (this.fClass) {
      var objMgr = this.fClass.GetObjMgr();
      objMgr.SetObjectList(this.fObjMgrList, this.fObjMgrNonPersist);
    }

    var n = this.fObjList.length;
    for (var i = 0; i < n; i++) {
      var serialObj = this.fObjList[i];
      serialObj.Restore(true);
    }

    for (var i = 0; i < n; i++) {
      var serialObj = this.fObjList[i];
      serialObj.RestoreFilterState(serialObj.fSourceObj);
    }
  }
}
